import axios from 'axios'
import router from '@/router/router-static'
import storage from '@/utils/storage'

const API_BASE = (process.env.VUE_APP_API_BASE || '/springboot6hv37').replace(/\/$/, '')
const http = axios.create({
    timeout: 1000 * 86400,
    withCredentials: true,
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json; charset=utf-8'
    }
})
// 请求拦截
http.interceptors.request.use(config => {
    // 临时测试：如果没有token，设置一个假的token或者不设置
    let token = storage.get('Token');
    if (token) {
        config.headers['token'] = token; // 请求头带上token
    }
    return config
}, error => {
    return Promise.reject(error)
})
// 响应拦截
http.interceptors.response.use(response => {
    if (response.data && response.data.code === 401) { // 401, token失效
        router.push({ name: 'login' })
    }
    return response
}, error => {
    return Promise.reject(error)
})
export default http